import { getAuthSession, isDevelopment } from '@/helpers';

export const fetchDocument = async (url: string): Promise<Response> => get(url);

const get = async (url: string): Promise<Response> => {
  const { accessToken } = getAuthSession();

  const headers: { [key: string]: string } = {
    Accept: 'application/pdf',
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  };

  if (!isDevelopment) headers.apikey = import.meta.env.VITE_RESURS_API_KEY;

  return fetch(url, {
    headers,
    method: 'GET',
  }).then(async (response) => {
    if (response.status !== 200) {
      throw Error(`Could not fetch document.`);
    }

    return response;
  });
};
